import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { IPropertyChangeHandler } from '../PropertyGrid';
import { MappingTypeSelector } from './MappingTypeSelector';
import { EditorConfigButtons } from 'components/Editors/EditorConfigButtons';
import { EditorConfigButton } from 'components/Editors/EditorConfigButton';
import { getMappingFieldPath } from './utils/MappingSelectorUtils';
import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';

interface IListMappingItemProps {
  node: ContextProviderNode;
  path: string[];
  onChange: IPropertyChangeHandler;
}

/**
 * Mapping Type Selector for an item with in a build-array or similar mapping.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ListMappingItem({ node, onChange, path }: IListMappingItemProps) {
  const nestedPath = [...path, node.Node.Name];
  return (
    <MappingTypeSelector child={node as IPropertyChild} path={nestedPath} key={nestedPath.join(',')}>
      <EditorConfigButtons>
        <EditorConfigButton onClick={() => onChange('+remove', getMappingFieldPath(node, nestedPath))}>
          Remove
        </EditorConfigButton>
      </EditorConfigButtons>
    </MappingTypeSelector>
  );
}
